import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, ModalInner, Button, Text } from 'components';

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  amount: number;
  orderId: string;
  currency?: 'KRW' | 'USD';  // 통화 정보 추가
}

const SuccessModal: React.FC<SuccessModalProps> = ({ 
  isOpen, 
  onClose, 
  amount, 
  orderId,
  currency = 'KRW'  // 기본값은 KRW
}) => {
  const navigate = useNavigate();

  const handleConfirm = () => {
    onClose();
    navigate('/manage-contacts');
  };

  // 통화별 포맷팅
  const formatAmount = () => {
    if (currency === 'USD') {
      return `$${amount.toLocaleString(undefined, { 
        minimumFractionDigits: 2, 
        maximumFractionDigits: 2 
      })}`;
    }
    return `₩${amount.toLocaleString()}`;
  };

  return (
    <Modal isOpened={isOpen}>
      <ModalInner className="md:w-[450px]" title="Payment Completed" onClickClose={onClose}>
        
        <div className="flex flex-col items-center gap-4 p-4 pt-0 w-full">
          <img 
            width="80px" 
            src="https://static.toss.im/illusts/check-blue-spot-ending-frame.png" 
            alt="Payment success" 
            className="mt-4"
          />
          <div className="flex flex-col gap-2 w-full mt-4">
            <div className="flex justify-between w-full">
              <Text weight="regular" color="tertiary">Amount</Text>
              <Text weight="medium">{formatAmount()}</Text>
            </div>
            <div className="flex justify-between w-full">
              <Text weight="regular" color="tertiary">Order Number</Text>
              <Text weight="medium">{orderId}</Text>
            </div>
          </div>
        </div>

        <div className="flex w-full flex-row items-center justify-center bg-bg-transparent_gray_light p-4">
          <Button 
            className="h-9"
            text="확인"
            onClick={handleConfirm}
            type="blue" 
            size="large" 
          />
        </div>

      </ModalInner>
    </Modal>
  );
};

export default SuccessModal;